import styled from "styled-components";

import { theme } from '../../configuration';

const HelpResultLink = styled.a`
  color: #000000;
  text-decoration: none;
  font-size: 0.9em;
  border-bottom: ${props => props.gettingStarted ? '1px solid #dfead2#' : '1px solid #ffffff'};
  cursor: pointer;
  
  display: flex;
  align-items: center;
  
  &:hover {
    color: ${theme.colours.main};
  }
`;

export default HelpResultLink;
